module.exports = __webpack_public_path__ + "img/avatar-man.b54c36d0.svg";